var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div>\n<p class=\"next-times-service-unavailable-prompt\" translate translate-params-service=\"$ctrl.service.name\">Valitettavasti palvelulle <strong>{{ service }}</strong> ei voi tällä hetkellä varata aikaa verkossa.</p>\n<p class=\"next-times-service-unavailable-prompt\" translate>Soita asiakaspalveluun varataksesi ajan: <a href=\"tel:+358104003400\">010 400 3400</a></p>\n</div>\n";
var id1="app/next-times/non-reservable-notice.tpl.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;


//////////////////
// WEBPACK FOOTER
// ./src/app/next-times/non-reservable-notice.tpl.html
// module id = 459
// module chunks = 0